<template>
  <div class="inventoryRp">
      <!-- 仓库对卖家发起积分扣减 -->
		<el-dialog
		:title="pointObj ? $t('other.a1853')+ pointObj.userName + $t('other.a1854') : ''"
		:visible.sync="payPoint"
		:close-on-click-modal="false"
		width="30%"
		>
        <div style="margin-bottom:30px">
            {{$t('other.a1855')}}：
            <el-select v-model="pointObj.storeId" :placeholder="$t('other.a653')" size="small" style="width:250px;">
                <el-option v-for="item in storeList" :key="item.storeId" :label="item.storeName" :value="item.storeId">
                </el-option>
            </el-select>
        </div>
		<div style="margin-bottom:30px">
			{{$t('other.a1856')}}：
			<el-input-number size="mini" v-model="pointObj.payIntegral"   :label="$t('other.a936')"></el-input-number>
		</div>

		<el-input
		type="textarea"
		:autosize="{ minRows: 2, maxRows: 120}"
		:placeholder="$t('other.a1857')"
		v-model="pointObj.desc">
		</el-input>
		<span slot="footer" class="dialog-footer">
			<el-button @click="payPoint = false">{{$t('other.a106')}}</el-button>
			<el-button type="primary" @click="updataPoint()">{{$t('other.a279')}}</el-button>
		</span>
		</el-dialog>

		
    <!-- 仓库帐号设置卖家优惠 弹窗-->
		  <el-dialog
		  :title="targetItem ? targetItem.userName + $t('other.a1858') : ''"
		  :visible.sync="discountDia"
		  width="50%"
		  >
      <div class="discountWrapper">
          <el-button size="medium" type="primary" @click="addNewDiscount()">{{$t('other.a1859')}}</el-button>
          <div class="discount">
              <p>{{$t('other.a1860')}}</p>
          </div>
      </div>
      <div>
        <el-table
        border
        size="mini"
			:data="sellerDiscountList"
            :key="itemKey"
			style="width: 100%">
			<el-table-column
				:label="$t('other.a1861')"
				>
				<template slot-scope="props">
					<span v-show="!props.row.checked">{{showStoreName(props.row.storeId)}}</span>
                    <el-select v-show="props.row.checked"  v-model="props.row.storeId" :placeholder="$t('other.a653')" size="small">
                    <el-option v-for="item in storeList" :key="item.storeId" :label="item.storeName" :value="item.storeId">
                    </el-option>
					</el-select>
				</template>
			</el-table-column>
			<el-table-column
				prop="discountType"
				:label="$t('other.a1842')"
				>
				<template slot-scope="props">
					<span v-show="!props.row.checked">{{hdknv(props.row.discountType)}}</span>
                    <el-select v-show="props.row.checked" @change="changeDesc(props.row)"  v-model="props.row.discountType" :placeholder="$t('other.a653')" size="small">
                    <el-option v-for="item in discountType" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
					</el-select>
                    
					
				</template>
			</el-table-column>
			<el-table-column
				prop="rate"
				:label="$t('other.a1862')">
				<template slot-scope="props">
					<span v-show="!props.row.checked">{{props.row.rate}}</span>
					<el-input v-show="props.row.checked" size="small" v-model="props.row.rate" :placeholder="testDesc"></el-input>
				</template>
			</el-table-column>
			<el-table-column
				:label="$t('other.a33')"
				>
				<template slot-scope="props">
					<el-button v-show=" !props.row.checked" size="mini" type="primary" @click="modify(props.row,props.$index)">{{$t('other.a93')}}</el-button>
					<el-button v-show=" props.row.checked" size="mini" type="danger" @click="comfirm(props.row,props.$index)">{{$t('other.a38')}}</el-button>
					<el-button v-show=" !props.row.checked" size="mini" type="info" @click="cancelSellerDiscount(props.row,props.$index)">{{$t('other.a312')}}</el-button>
                    <el-button v-show=" props.row.checked" size="mini" type="info" @click="cancelChange(props.row,props.$index)" >{{$t('other.a146')}}</el-button>
				</template>
			</el-table-column>
			</el-table>
      </div>
     
		  <span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="discountDia = false">{{$t('other.a5')}}</el-button>
		  </span>
		</el-dialog>


      <div class="desc">
          <div class="titleDesc">{{$t('other.a1863')}}</div>
         <div class="remindData">
             <div class="oknkg">
                <span class="store">{{stockReminder}}{{$t('other.a707')}}</span>
                <span class="rich"></span>
                <span class="okng">{{$t('other.a1864')}}</span>
                <span class="notrich"></span>
                <span class="okng">{{$t('other.a1865')}}</span>
             </div>
             <div>
                 <div class="btn">
                    <!-- 卖家帐号查询：<el-input size="medium" style="width:350px;margin:0 5px;" v-model="orderId" :placeholder="$t('other.a764')"></el-input> -->
                </div>
             </div>
         </div>
      </div>
      <div>
          <el-table 
					:data="logsList"
					ref="multipleTable"
					border>
						<el-table-column :label="$t('other.a465')"  :show-overflow-tooltip="true">
							<template scope="scope" >
                                <div>
								<span>{{scope.row.userName}}</span>
                                <i v-if="scope.row.partnerId" class="iconfont icon-biaoji"></i>

                                </div>
                                <!-- <span>{{scope.row.payType}}</span> -->
							</template>
						</el-table-column >
            <el-table-column :label="$t('other.a1866')"  :show-overflow-tooltip="true">
							<template scope="scope" >
								<span>{{scope.row.userId}}</span>
							</template>
						</el-table-column >
                        <el-table-column :label="$t('other.a1867')"   :show-overflow-tooltip="true">
							<template scope="scope" >
								<span v-if="scope.row.userIntegral > 30" class="rich"></span>
                                <div v-else>
                                    <span  class="notrich"></span>
                                <span  class="noEnougthDesc">{{$t('other.a1868')}}</span>
                                </div>
                                
							</template>
						</el-table-column >
            <el-table-column :label="$t('other.a89')"   prop="createTime" :show-overflow-tooltip="true">
                        <template scope="scope" >
                            <span>{{scope.row.createTime}}</span>
                        </template>
						</el-table-column >     
						<el-table-column  :label="$t('other.a33')">
							<template scope="scope">
                                <el-button size="mini" type="warning" @click="setDiscount(scope.row)">{{$t('other.a1869')}}</el-button>
								<el-button size="mini" v-show="userId == 'ABH_Int' || userId== 'thstock'" type="primary" @click="getPointParam(scope.row)">{{$t('other.a1870')}}</el-button>
                                <el-button size="mini" v-show="!scope.row.hidden"  type="primary" @click="hideSeller(scope.row,scope.$index)">{{$t('other.a1871')}}</el-button>
                                <el-button size="mini" v-show="scope.row.hidden"  type="info" @click="showSeller(scope.row,scope.$index)">{{$t('other.a1872')}}</el-button>
							</template>
						</el-table-column>
					</el-table>

             <div class="pagination">

                 <el-pagination
                background
                size="mini"
                @current-change="handleCurrentChange"
                layout="prev, pager, next"
                :total="stockReminder">
                </el-pagination>
             </div>       
      </div>
  </div>
</template>

<script>
import utils from '../../utils/utils'
import shopaccessApi from '../../api/moudles/shopaccess'
import deductionApi from '../../api/moudles/deduction'
import userStoreItems from '../../api/moudles/userStoreItems'
import * as echarts from 'echarts';
import { mapState, mapActions, mapMutations} from 'vuex'
export default {
data(){
return{
    sellerList:[],
    pointObj:{
        payIntegral:0,
        desc:null
    },
    sellerDiscountList:[],
    storeList:[],
    page:0,
    stockReminder:0,
    payPoint:false,
    testDesc:this.$t('other.a1873'),
    itemKey:0,
    orderId:null,
    discountDia:false,
    targetItem:null,
    userId:JSON.parse(localStorage.getItem('userInfo')).userId,
    indexOne:null,
    discountType:[{
        value:0,
        label:this.$t('other.a910')
    },{
        value:1,
        label:this.$t('other.a1874')
    },{
        value:2,
        label:this.$t('other.a1875')
    },{
        value:3,
        label:this.$t('other.a1876')
    },{
        value:4,
        label:this.$t('other.a1877')
    },{
        value:5,
        label:this.$t('other.a1878')
    },],
    sellerid:[]


}
},
computed:{

    logsList(){
        
        let list=JSON.parse(JSON.stringify(this.sellerList))
        
        let page=this.page
        this.stockReminder=list.length

        let list4=list.splice(page,10)

        console.log('list4',list4)
        return list4

    },

},
watch:{
    payPoint(){
        if(!this.payPoint){
            this.pointObj.payIntegral=0
            this.pointObj.desc=null

        }
    }
},
created(){
    this.storeList=JSON.parse(localStorage.getItem('userInfo')).stores
    this.getHideSellerList()
},
methods:{

    ...mapActions('userStoreItems', [
        'getStockRemind',
    ]),
    //获取隐藏的卖家列表
    getHideSellerList(){
        shopaccessApi
        .getBanedSeller({
            storeId:this.storeList[0].storeId,
            userId:this.userId,
        })
        .then(res => {
        if(res.code === 200 ){
            let list=res.data
            let that=this
            let sellerid=[]
            if(Array.isArray(list)){
                list.forEach(p => {
                    sellerid.push({
                        userName:p.sellerId,
                        userId:p.sellerId,
                        createTime:this.$t("other.a354"),
                        hidden:true
                    })
                })
            }
            this.sellerList=JSON.parse(localStorage.getItem('userInfo')).sellers
            this.sellerList.forEach(p => {
                p.createTime=utils.renderTime(p.createTime)
            })
            this.sellerList.unshift(...sellerid)
            


            
            console.log('sellerList',this.sellerList)
        }else{
        this.$message.warning(res.msg)
        }
        })
    },
    //隐藏卖家
    hideSeller(item,index){
        console.log(item);
        shopaccessApi
        .addBanedSeller({
            sellerId:item.userId,
            storeId:this.storeList[0].storeId,
            userId:this.userId,
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.$message.success(this.$t('other.a1879'))
        item.hidden=true
        this.$set(this.sellerList,index,item)
        }else{
        this.$message.warning(res.msg)
        }
        })
    },
    //显示卖家
    showSeller(item,index){
        console.log(item);
        item.hidden=false
        shopaccessApi
        .delBanedSeller({
            sellerId:item.userId,
            storeId:this.storeList[0].storeId,
            userId:this.userId,
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.$message.success(this.$t('other.a1879'))
        this.$set(this.sellerList,index,item)
        }else{
        this.$message.warning(res.msg)
        }
        })
    },

    updataPoint(){
        this.pointObj.userId=this.userId
        let obj=JSON.parse(JSON.stringify(this.pointObj))
        obj.payIntegral=-obj.payIntegral
        // 负数为扣减卖家积分，正数为退还卖家积分

        if(obj.payIntegral== 0 ){
            this.$message.warning(this.$t('other.a1880'))
            return
        }else if(!obj.desc){
            this.$message.warning(this.$t('other.a1881'))
            return
        }
        console.log('deductionPoints',obj)
        shopaccessApi
        .deductionPoints(obj)
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.$message.success(this.$t('other.a1882'))
        this.payPoint=false
        }else{
        this.$message.warning(res.msg)
        }
        })
    },

    addNewDiscount(){
        this.sellerDiscountList.unshift({
            userId:this.userId,
            storeId:null,
            sellerId:this.targetItem.userId,
            discountType:null,
            rate:null,
            checked:true,
            newFlag:true

        })

        console.log('sellerDiscountList',this.sellerDiscountList)
    },


    showStoreName(id){
        return utils.showstoreNameBystoreId(id)
    },

    changeDesc(item){
        
        if(item.discountType == 0){
            this.testDesc=this.$t('other.a1883')
            item.rate=null
        }else{
            this.testDesc=this.$t('other.a1873')
            item.rate=null
        }
        this.itemKey++
    },

    hdknv(id){
			const params={
				'0':this.$t('other.a910'),
				'1':this.$t('other.a1874'),
				'2':this.$t('other.a1875'),
				'3':this.$t('other.a1876'),
				'4':this.$t('other.a1877'),
				'5':this.$t('other.a1878')
			}

			return params[id]
		},

    modify(item,index){
        item.checked=true
        this.itemKey++
    }, 
    
    cancelSellerDiscount(item,index){
        this.$confirm(this.$t('other.a608'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            shopaccessApi
            .deleteSellerDiscount({discountId:item.discountId,storeId:item.storeId,userId:this.userId})
            .then(res => {
                if(res.code === 200) {
                    this.$message.success(this.$t('other.a1232'))
                    this.sellerDiscountList.splice(index,1)
                }
            })
        })
        
        
    },
    
    cancelChange(item,index){
        if(item.newFlag){
            this.sellerDiscountList.splice(index,1)
        }else{

            item.checked=false
            this.itemKey++
        }
    },  



    comfirm(item){
        let ttp=JSON.parse(JSON.stringify(item))

        if( ttp.discountType == 0 &&  ttp.rate < 0.6){
        
            this.$message.warning(this.$t('other.a1884'))
            return
        }

        item.checked=false
        let obj=JSON.parse(JSON.stringify(item))
        obj.userId=this.userId

        this.itemKey++

        shopaccessApi
        .setSellerDiscount(obj)
        .then(res => {
            if(res.code === 200) {
                console.log('resdata',res.data)
                this.$message.success(this.$t('other.a665'))
                
            }else{
                this.$message.warning(res.msg)
            }
        })
    },



    

    getPointLog(){
        deductionApi
        .getIntegralLog(this.logparams)
        .then(res => {
            if(res.code === 200) {
                console.log('收入支出',res.data.logs)
                
                let listCopy=res.data.logs.filter(p => {
                    p.sellerUserId=p.sellerUserId == "0"  ? p.payWith :p.sellerUserId
                    if(utils.logFilterByPayType(p.payType,'STORE')){
                        return p
                    }
                })

                this.updataFeeBtn(listCopy)

                console.log(';listCopy',listCopy)
                listCopy.forEach(p => {
                    p.createTime=utils.getCurrnetTime(p.createTime)
                    p.logDesc=null
                    if(p.orderDeductions){
                        p.logDesc=p.orderDeductions.map(p => {
                            return  Math.abs(p.orderFee.toFixed(2) )+ "积分--" +p.desc
                        })
                    }
                })
                this.orderList=listCopy
                
               

                
            }else{
                this.$message.warning(res.msg)
            }
        })
    },

    showChange(id){
        
        let ttp=this.payTypeOptions.find(item => item.value == id)
        if(ttp){
            return ttp.label
        }else{
            return id
        }
    },

    showSellerName(id){
        let ttp=this.allseller.find(item => item.userId == id)
        if(ttp){
            return ttp.userName
        }else{
            return id
        }
    },

    exportXlm(){
        this.showLoading()
        let that=this
        let obj=JSON.parse(JSON.stringify(this.logparams))
        obj.offset=this.stockReminder+5
        deductionApi
        .getIntegralLog(obj)
        .then(res => {
            if(res.code === 200) {
                console.log('收入支出',res.data)
                let list=res.data.logs
                let arr=[]
                list.forEach(p => {
                    p.createTime=utils.getCurrnetTime(p.createTime)
                    p.desc=[]
                    p.orderDeductions.forEach(i => {
                         p.desc.push('/' +i.orderFee + '积分，' + i.desc + '/')
                    })
                    arr.push({
                        '费用类型':that.showChange(p.payType),
                        '订单号':p.payOrderId,
                        '积分变化':p.changeIntegral,
                        '可用积分':p.newIntegral,
                        '支付来源':that.showSellerName(p.payWith),
                        '时间':p.createTime,
                        '扣减明细':p.desc.join('&'),
                        
                    })
                })
                console.log('arr',arr)

                let list2=['费用类型','订单号','积分变化','可用积分','支付来源','时间','扣减明细']

                utils.exPortEXml(arr,list2,list2)
                console.log('list',list)
              
            }else{
                this.$message.warning(res.msg)
            }
        })


       
    },

    changeSort(val){
        console.log('jkdfn',val)
         if(this.type == 0){
            let list=JSON.parse(JSON.stringify(this.remindData))

             this.sortOrderData(list,val.order,val.prop)
            
        }else if(this.type == 1){
            let list=JSON.parse(JSON.stringify(this.outOfstockReminder))
            this.sortOrderData(list,val.order,val.prop)
            
        }else{
            let list=JSON.parse(JSON.stringify(this.unsalable))
            this.sortOrderData(list,val.order,val.prop)
        }
    },

    sortOrderData(arr,order=null,type){
        let list=arr
        if(order == 'ascending'){
            arr.sort((a,b) => {
                return a[type]-b[type]
            })
        }else if(order == 'descending'){
            arr.sort((a,b) => {
                return b[type]-a[type]
            })
        }

        if(this.type ==0 ){
            this.remindData=arr
        }else if(this.type == 1){
            this.outOfstockReminder=arr
        }else{
            this.unsalable=arr
        }
    },



    getTime(){
        console.log(this.value6)
        this.logparams.end=utils.CurdateAddoneday(this.value6[1])
        this.logparams.start=this.value6[0]
        this.getPointLog()
    },

    getDataOfType(num){
        
        this.dataOfType=Number(num)
        let list=[]
        let list2=[]

        for(let i=0;i<this.dataOfType;i++){
            list.unshift(utils.getRecentSevenDay(-i))
            list2.unshift(0)
        }

        this.value6=[list[0],list[list.length-1]]
        this.logparams.end=utils.CurdateAddoneday(this.value6[1])
        this.logparams.start=this.value6[0]
        this.getPointLog()
    },

    getPointParam(item){
        this.pointObj.storeId=this.storeList[0].storeId
        this.pointObj.sellerId=item.userId
        this.pointObj.partnerId=item.partnerId
        this.pointObj.userName=item.userName
        this.payPoint=true
    },

    

    setDiscount(item){
      console.log(item)
      this.targetItem=item
			let params={
				sellerId:item.userId,
				storeId:this.storeList[0].storeId,
				userId:this.userId
				
			}
			shopaccessApi
			.getSellerDiscount(params)
			.then(res => {
				if(res.code === 200) {
					console.log('卖家优惠',res.data)
          this.sellerDiscountList=res.data
          this.discountDia=true
				}else{
          this.$message.warning(res.msg)
        }
			})
    },

    viewSales(item){
    console.log('item',item)
    this.dialogVisible=true
    this.mainItem=item
 
    },

    lgnk(item,start=null,end=null){
        let that=this
        var chartDom = document.querySelector('#main')
        var myChart = echarts.init(chartDom);
        let params={
            cusCode:item.cusCode,
            end:end ? utils.CurdateAddoneday(end) : utils.CurdateAddoneday(utils.getRecentDays(0)),
            start: start ? start : utils.getRecentDays(-30),
            offset:50,
            type:1,
            page:0,
            userId:this.userId
        }
        
        userStoreItems
		.getInstockoperaterecore(params)
		.then(res => {
			if(res.code === 200) {
				console.log('仓库库存操作日志',res.data)
                let mapList=new Map()
                this.totalAmount=0
               
                res.data.logs.forEach(p => {
                    p.createTime=utils.getCurrnetTime(p.createTime).slice(0,10)
                    p.decStock=Math.abs(p.decStock)
                   
                    
                    

                    let list=mapList.get(p.createTime)
                    if(!list || list == null || list == 'undefined'){
                        list={
                            outStock:0,
                            inStock:0,
                            returnStock:0
                        }
                    }
                    
                    if(p.type == 1 ){//出库扣减
                        
                        list.outStock+=p.decStock
                    }else if(p.type == 2){//入库单增加
                        list.inStock+=p.decStock
                    }else if(p.type == 3 ){//退货
                        list.returnStock+=p.decStock
                    }

                    mapList.set(p.createTime,list)

                })

                
                that.option.xAxis.data.forEach((p,index) => {
                    let ttp=mapList.get(p)
                    if(ttp){
                        that.option.series[0].data[index]=ttp.outStock
                        this.totalAmount+=ttp.outStock
                    }
                })
                console.log('mapList',mapList)
                console.log('that.option',that.option)
                that.option && myChart.setOption(that.option);
				
                
			}
		})
    },

    getData(item,num){
        console.log('remindData',this.remindData)
        if(num == 0){
            this.storeId = item.value
            this.logparams.storeIds=item.value == 0 ? null : [item.value] 
        }else if(num == 1){
            this.sellerId=item.value
            this.logparams.sellerIds=item.value
           
        }else if(num == 2){
            this.pointType=item.value
            this.logparams.payType=item.value
        }
        
       
    },

    getRecharge(){
        this.logparams.payType=this.pay_Value
        this.getPointLog()
    },

    upataOutOfStack(data){
        console.log(data)
        let arr=this.remindData.filter(p => {
            p.dayOfShip=Number(data.dayOfShip)
            p.salesAvg01=Number(p.salesAvg.toFixed(2))
            p.needStock01= data.type ? p.dayOfShip*2*p.salesAvg01-p.nowStock-p.shippedStock : p.dayOfShip*2*p.salesAvg01-p.nowStock
            return p
        })
        let list = arr.filter(p => {
            if( p.storeItem.storeId == this.storeId && p.needStock01> 0){
                return p
            }
        })
        console.log('arr',arr)

        list.forEach(i => {
            i.needStock01=Math.ceil(i.needStock01)
            i.salesAvg01=Math.ceil(i.salesAvg01)
        })
        console.log('list',list)
        this.outOfstockReminder=list
        this.timeList[1].num=list.length 
    },

    handleCurrentChange(val){
        console.log(val)
        this.page=Number(val-1)*10
        
    },

    fuzzyMatch(str, key) {
        
       
        str == null ? '' : str
        if(typeof(str) == Number) {
            return str==key
        }

        console.log(typeof(key))

        if(typeof(key) == 'string' && str) {
            console.log(str,key,key.indexOf(str))
            let ttp=false
            if(key.indexOf(str) > -1 || str == key){
                ttp=true
            }
            return ttp
        }else {
            return false;
        }
        
       
    },

    getStockRemindCopy(){
				new Promise((resolve,reject) => {
        let that=this
				this.getStockRemind({userId:this.userId,storeId:this.storeId}).then(res => {
					console.log('852',res)
						if(res.code == 200) {
                            this.originRemindOrder=res.data
							this.remindData=res.data.filter(p => {
                                p.lastTime=p.lastTime ? utils.getCurrnetTime(p.lastTime) : this.$t("other.a354")
                                p.salesAvgMonthly=p.salesAvgMonthly.toFixed(2)
                                p.goodsValue=p.storeItem.storeNum*p.storeItem.cost
                                if(p.storeItem.storeId == this.storeId){
                                    return p
                                }
                            })

                            console.log('remindData',this.remindData)

							this.unsalable=this.remindData.filter(k => {
								if(k.unsalable){
									return k
								}
							})
                            this.timeList[0].num=this.remindData.length

							console.log('unsalable',this.unsalable)
                            this.timeList[2].num=this.unsalable.length
							let arr=this.remindData.filter(p => {
								p.salesAvg01=Number(p.salesAvg.toFixed(2))
								p.needStock01=p.dayOfShip*2*p.salesAvg01-p.nowStock
								return p
							})
                            console.log('arr',arr)
							let list = arr.filter(p => {
								if( p.storeItem.storeId == that.storeId && p.needStock01> 0){
									return p
								}
							})
                            console.log('list1112',list)
							resolve(list)
						}
					})
				}).then(res => {
					res.forEach(i => {
						i.needStock01=Math.ceil(i.needStock01)
						i.salesAvg01=Math.ceil(i.salesAvg01)
					})
					this.outOfstockReminderAmont=res.length
					this.outOfstockReminder=res
                    this.timeList[1].num=res.length
					console.log('缺货提醒11',res)
				})
			},

}
}

</script>
<style lang='scss' scoped>
.inventoryRp{
    background-color: white;
    margin: 20px 15px;
    padding: 10px;
    border-radius: 5px;


    .discountWrapper{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;

    }

    .discount{
        color: red;
        font-size: 17px;
        font-weight: bold;
    }


    .icon-biaoji{
        font-size: 10px;
        color: rgb(245, 34, 45);
        position: relative;
        right: -3px;

    }

    .okng{
        margin:0 10px;
    }

    .oknkg{
        display: flex;
        align-items: center;
        color: #919099;
    }

    .pong{
        display: flex;

        .okng{
            font-size: 14px;
            color: #919099;
            cursor: pointer;
            margin-left: 30px;
            margin-bottom: 15px;
            padding: 3px 10px;
            border-radius: 3px;
        }

        .active{
            background-color: #66b1ff;
            padding: 3px 10px;
            border-radius: 3px;
            color: #fff;
        }
    }

    .iknkg{
        width: 100%;
        height: 300px;
        display: flex;
        justify-content: center;
    }

    .remindData{
       display: flex;
       margin-top: 30px;
       justify-content: space-between;

        .btn{
            text-align: right;
            margin-bottom:10px;
            margin-right: 30px;
        }
    }

    .itemWrapper{
        display: flex;
        margin-bottom: 5px;
    }



    .sokng{
        display: inline-block;
        min-width: 70px;
        text-align: center;
        margin: 0 10px;
        cursor: pointer;
        color: #919099;
        padding: 3px ;
        margin: 3px 5px 10px 3px;
         
    }

    .store{
        box-sizing: border-box;
        padding-top:5px;
        color: #919099;
        margin-right:30px
    }

    .rich{
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 3px;
        background-color: aquamarine;
    }

    .noEnougthDesc{
        font-size: 12px;
        margin-left: 5px;
    }

    .notrich{
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 3px;
        background-color: red;
    }

    .uykpg{
        width: 90px;
        margin-left:30px ;
        margin-right:30px ;
        box-sizing: border-box;
        padding-top:5px;
        color: #0d79f5;
        cursor: pointer;
    }
    .desc{
        width: 100%;


        .titleDesc{
            font-weight: bold;
            color: #616066;
            margin-bottom:30px;
            padding:0px 10px;
            font-size: 25px;
            text-align: center;
        }

        


    }

    .active{
        color: #fff;
        background-color: #66b1ff;
        padding: 3px ;
        border-radius: 3px;
    }

    .pagination{
        text-align: right;
        margin-top: 18px;
        margin-right: 30 ;
    }

}
</style>